import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Megaphone } from "lucide-react";

import FeedbackWidget from "../components/Common/FeedbackWidget";

const slugify = (value) =>
	String(value || "")
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "");

const PageTitle = ({ motherMenu, activeMenu, pageContent, hideFeedback = false, feedbackSource }) => {
	useParams(); // keep hook consistent with previous signature
	const [showFeedback, setShowFeedback] = useState(false);

	const source = feedbackSource || slugify(activeMenu) || slugify(motherMenu) || "page";

	return (
		<div className="row page-titles mx-0">
			<div className="page-titles-row">
				<ol className="breadcrumb">
					<li className="breadcrumb-item active">{motherMenu}</li>
					<li className="breadcrumb-item">{activeMenu}</li>
				</ol>
				{!hideFeedback && (
					<button
						type="button"
						onClick={() => setShowFeedback(true)}
						className="dashboard-feedback-link page-titles-feedback"
					>
						<Megaphone size={13} strokeWidth={1.75} />
						Feedback
					</button>
				)}
			</div>
			{!hideFeedback && (
				<FeedbackWidget
					show={showFeedback}
					onHide={() => setShowFeedback(false)}
					source={source}
				/>
			)}
		</div>
	);
};

export default PageTitle;
